import { useQuery } from '@apollo/client';

import GET_CENTRALIZED_DATA_QUERY from './graphql/get-centralized-data.v5.graphql';
import type {
  LibraryCrehanaAuthGetCentralizedData,
  LibraryCrehanaAuthGetCentralizedDataVariables,
} from './graphql/types/LibraryCrehanaAuthGetCentralizedData';

export const useGetCentralizedSessionData = (
  organizationSlug: string,
  skip: boolean,
) => {
  const { data, loading, error } = useQuery<
    LibraryCrehanaAuthGetCentralizedData,
    LibraryCrehanaAuthGetCentralizedDataVariables
  >(GET_CENTRALIZED_DATA_QUERY, {
    variables: {
      organization_slug: organizationSlug,
    },
    skip,
    context: {
      clientName: 'v5',
    },
    fetchPolicy: 'cache-first',
  });

  if (skip) {
    return {
      userOrganizationSlug: undefined,
      isCentralizedCorporationSuperAdmin: false,
      loading: false,
      error: undefined,
    };
  }

  if (loading) {
    return {
      userOrganizationSlug: undefined,
      isCentralizedCorporationSuperAdmin: false,
      loading: true,
      error: undefined,
    };
  }

  if (error) {
    return {
      userOrganizationSlug: undefined,
      isCentralizedCorporationSuperAdmin: false,
      loading: false,
      error: true,
    };
  }

  const centralizedSession =
    data?.security.current_session?.centralized_session;
  const adminSlugs = centralizedSession?.centralized_admin_organization_slugs;

  if (!centralizedSession) {
    return {
      userOrganizationSlug: undefined,
      isCentralizedCorporationSuperAdmin: false,
      loading: false,
      error: undefined,
    };
  }

  return {
    userOrganizationSlug: centralizedSession.centralized_organization_slug,
    isCentralizedCorporationSuperAdmin: Boolean(adminSlugs?.length),
    loading: false,
    error: undefined,
  };
};
